import { useQuery } from "@tanstack/react-query";
import { getDailyTaskRwo } from "../api/tasks";
import { DailyTaskRwo } from "../types/dailyTaskRwo";

export const rwoTaskKeys = {
  all: ["hr-daily-task-rwo"] as const,
  list: (attendanceId: string) =>
    [...rwoTaskKeys.all, "list", attendanceId] as const,
};


export const useDailyTaskRwo = (attendanceId: string) => {
  return useQuery<DailyTaskRwo[]>({
    queryKey: rwoTaskKeys.list(attendanceId),
    queryFn: () => getDailyTaskRwo(attendanceId),
    enabled: !!attendanceId,
    staleTime: 1000 * 60 * 60 * 3,
    gcTime: 1000 * 60 * 60 * 3,
    refetchOnWindowFocus: true,
  });
};
